export default "__VITE_ASSET__kT2Hn8yX__"